import { Component, OnInit, ViewEncapsulation, AfterViewInit, Renderer2 } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CoreConfigService } from "@core/services/config.service";
import { Property, PropertyType } from "app/modules/admin/properties/property.model";
import { LandingService } from "../landing.service";
import { Amenities, Search } from "../search.model";
import { environment } from "environments/environment";
import { CurrencyPipe } from "@angular/common";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { User } from "app/auth/models/user";
import { PropertyService } from "../../../../../app/modules/admin/properties/property.service";
declare var google: any;
import Swal from "sweetalert2";

@Component({
  selector: "app-resultados-busqueda",
  templateUrl: "./resultados-busqueda.component.html",
  styleUrls: ["./resultados-busqueda.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class ResultadosBusquedaComponent implements OnInit {
  public listener: () => void;
  map;
  inicio = { lat: 22.151784, lng: -100.976407 };
  temp: Array<object> = [];
  properties = [];
  page = 1;
  pageSize = 9;
  sizeTable = 0;
  userLoggeado: User = null;

  url = environment.URL_AWS;
  mapa: boolean = false;
  button: string = "Mapa";
  consulta: Search;
  markers: any[] = [];
  bandProvince: boolean = true;

  modalUbi = null;

  orders = [
    // { id: 1, name: "Precio: menor al mayor", sort: { value: "price", direction: "asc" } },
    // { id: 2, name: "Precio: mayor al menor", sort: { value: "price", direction: "desc" } },
    { id: 3, name: "Fecha: Lo más reciente", sort: { value: "created_at", direction: "desc" } },
    { id: 4, name: "Fecha: Lo más antiguo", sort: { value: "created_at", direction: "asc" } },
    { id: 5, name: "Puntuación: Más alto", sort: 'desc'},
    { id: 6, name: "Puntuación: Más bajo", sort: 'asc' },
  ];

  ord: any = { id: 3, name: "Fecha: Lo más reciente", sort: { value: "created_at", direction: "desc" } };
  ordView: any = { id: 3, name: "Fecha: Lo más reciente", sort: { value: "created_at", direction: "desc" } };
  ordScore: any = { id: 5, name: "Puntuación: Más alto", sort: 'desc' };
  bandOrdScore = false;

  parametrosBusqueda: Search = {
    types: "",
    propertyTypes: null,
    range: {
      upper: null,
      upperText: "",
      lower: null,
      lowerText: "",
    },
    amenities: [],
    suburbs: null,
  };

  obligatorios: boolean = false;
  precioMal: boolean = false;
  operationTypes = [{ name: "Venta" }, { name: "Renta" }];

  gardenOpt = [
    { name: "Con jardín", value: 1 },
    { name: "Sin jardín", value: 0 },
  ];

  propertyTypes: PropertyType[] = [];

  bedrooms: any[] = [
    { name: "1+", value: 1 },
    { name: "2+", value: 2 },
    { name: "3+", value: 3 },
    { name: "4+", value: 4 },
  ];

  bathrooms: any[] = [
    { name: "0.5+", value: 0.5 },
    { name: "1+", value: 1 },
    { name: "1.5+", value: 1.5 },
    { name: "2+", value: 2 },
    { name: "2.5+", value: 2.5 },
    { name: "3+", value: 3 },
    { name: "3.5+", value: 3.5 },
    { name: "4+", value: 4 },
    { name: "4.5+", value: 4.5 },
  ];

  garageOpt: any[] = [
    { name: "1+", value: 1 },
    { name: "2+", value: 2 },
    { name: "3+", value: 3 },
  ];

  nivelesOpt: any[] = [
    { name: "1+", value: 1 },
    { name: "2+", value: 2 },
    { name: "3+", value: 3 },
  ];

  terrazaOpt = [
    { name: "Con terraza", value: 1 },
    { name: "Sin terraza", value: 0 },
  ];

  amuebladoRentaOpt = [
    { name: "Amueblado", value: 1 },
    { name: "Sin amueblar", value: 0 },
  ];

  yearsAnt = [
    { name: "Menos de 5 años", value: 1 },
    { name: "Menos de 15 años", value: 2 },
    { name: "Menos de 40 años", value: 3 },
    { name: "40 o más años", value: 4 },
  ];

  suburbsBasic: any[] = [];
  suburbLoading = false;

  statesBasic: [] = [];
  stateLoading = false;

  provincesBasic: [] = [];
  provinceLoading = false;
  exclusive = false;

  province = {
    name: "",
    id: 0,
  };

  state = {
    name: "San Luis Potosí",
    id: 24,
  };
  noResultados: boolean = false;
  amenities: Amenities[];
  amenities_base: Amenities[];
  amenities_ops: Amenities[];
  years: Amenities = {
    id: 23,
    name: "Años anti",
    icon: "",
    cant: null,
    selected: false,
    status: "1",
    tipo: 1,
    description: "",
    switch: false,
  };
  config;
  showBusquedaAvanzada: boolean = false;
  iconShowBusquedaAvanzada = "chevron-down";

  lead;
  tipo;

  stars = Array(5).fill(0);
  hoverIndexes: number[] = [];

  constructor(
    private _coreConfigService: CoreConfigService,
    private _LandingService: LandingService,
    private _router: Router,
    private _currencyPipe: CurrencyPipe,
    private modalService: NgbModal,
    private _route: ActivatedRoute,
    private _propertyService: PropertyService,
    private renderer: Renderer2
  ) {
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true,
        },
        menu: {
          hidden: true,
        },
        footer: {
          hidden: true,
        },
        customizer: false,
        enableLocalStorage: false,
      },
    };

    var host = window.location.host;
    const subdomain = host.split(".")[1];
    let data;
    if (subdomain == "in-mo" || subdomain == "inmoapp") {
      data = {
        domain: host.split(".")[0],
      };
    } else {
      data = {
        domain: environment.DOMAIN,
      };
    }
    this._LandingService.getConfig(data).then(
      (data: any) => {
        console.log(data);
        this.config = data;
        const style = document.createElement("style");
        style.innerHTML = `.page-item.active .page-link {
         background-color:${this.config?.primaryColor} !important;
     }
     .custom-control-input:checked~.custom-control-label:before {
      background-color:${this.config?.primaryColor} !important;
      border-color:${this.config?.primaryColor} !important;
  }`;

        document.body.appendChild(style);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  llamadoAnteriorDeComponente() {
    this.consulta = this._LandingService.sharingValue;
    console.log("CONSULTA VARIABLE", this.consulta);
    this.parametrosBusqueda = this._LandingService.sharingValue;
    var host = window.location.host;
    const domain = host.split(".")[1];
    let params;
    if (domain == "in-mo" || domain == "inmoapp") {
      params = {
        data: this.consulta,
        type: 1,
        domain: host.split(".")[0],
      };
    } else {
      params = {
        data: this.consulta,
        type: 1,
        domain: environment.DOMAIN,
      };
    }

    if (localStorage.getItem("currentUser")) {
      this.userLoggeado = JSON.parse(localStorage.getItem("currentUser"))?.user;
    }

    if (this.userLoggeado) {
      this._LandingService.allPropertiesSearchResults(params, this.userLoggeado.id).then(
        (resp: Property[]) => {
          console.log(resp);

          this.properties = this.temp = resp;
          if (this.properties.length < 1) {
            this.noResultados = true;
          }
          this.sizeTable = this.temp.length;
          this.pageSize = 9;
          this.getPageData();
        },
        (error: any) => {
          console.log(error);
        }
      );
    } else {
      this._LandingService.allPropertiesSearchResults(params).then(
        (resp: Property[]) => {
          console.log(resp);
          this.properties = this.temp = resp;
          if (this.properties.length < 1) {
            this.noResultados = true;
          }
          this.sizeTable = this.temp.length;
          this.getPageData();
          this.pageSize = 9;
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }

  async ngOnInit() {
    const id = this._route.snapshot.paramMap.get("id");
    this.tipo = this._route.snapshot.paramMap.get("tipo");
    console.log("ID", id);
    console.log("TIPO", this.tipo);

    if(this.ordView.id == 5 || this.ordView.id == 6){
      this.ordScore = this.ordView;
      console.log("ORDEN", this.ordScore);
      this.ord = { id: 3, name: "Fecha: Lo más reciente", sort: { value: "created_at", direction: "desc" } };
      this.bandOrdScore = true;
    } else {
      this.ord = this.ordView;
      this.bandOrdScore = false
    }

    await this.getLead();
    if (this.tipo == "manual") {
      await this.getPropertiesManuallyCoincidences(id);
    } else {
      await this.getPropertiesAutomaticallyCoincidences(id);
    }
  }

  async getLead() {
    console.log("ENTRO getLead()");
    const id = await this._route.snapshot.paramMap.get("id");
    await this._LandingService.getClientNoLogin(parseInt(id)).then(
      async (lead: any) => {
        console.log("getLead()", lead);
        if (lead.id !== -1) {
          this.lead = lead;
          let property_types = [];
          lead.property_type_clients.forEach((element) => {
            property_types.push(element.property_type);
          });
          this.lead.propertyTypes = property_types;
          let suburs = [];
          lead.client_suburbs.forEach((element) => {
            suburs.push(element.suburb);
          });
          this.lead.suburbs = suburs;
          this.lead.fromPriceText = lead.fromPrice.toString();
          this.lead.toPriceText = lead.toPrice.toString();
        } else {
          Swal.fire("Error de servidor", "No se pudo obtener el lead", "error");
        }
      },
      (error: any) => {
        console.log("Error de servidor GTNL", error);
        Swal.fire("Error de servidor GTNL", "Favor de intentarlo nuevamente", "error");
      }
    );
  }

  async getPropertiesManuallyCoincidences(id) {
    console.log("ENTRO getPropertiesManuallyCoincidences()");

    let params = {
      assigned_type: 2,
      ord: this.ord.sort.value,
      ordDirection: this.ord.sort.direction,
      client_id: id,
    };

    console.log("PARAMS getPropertiesManuallyCoincidences()", params);
    await this._LandingService.getClientPropertiesProperties(params).then(
      async (resp: any) => {
        this.properties = this.temp = resp.data;
        console.log("RESP getPropertiesManuallyCoincidences", resp);
        if(this.bandOrdScore) this.sortByScore();
        console.log("PROPERTIES", this.properties);
      },
      (error: any) => {
        console.log("Error de servidor GTPP", error);
        Swal.fire("Error de servidor GTPP", "Favor de intentarlo nuevamente", "error");
      }
    );
  }

  sortByScore(){
    if(this.ordScore.sort == 'desc'){
      console.log("DESC");
      this.properties.sort((a, b) => b.valoracion - a.valoracion);
    } else {
        console.log("ASC");
      this.properties.sort((a, b) => a.valoracion - b.valoracion);
    }
  }

  async getPropertiesAutomaticallyCoincidences(id) {
    let new_propertyTypes = [];
    console.log();
    for (let x of this.lead.propertyTypes) new_propertyTypes.push(x.id);

    let parametrosBusqueda = {
      state_id: this.lead.state_id,
      exclusive: false,
      province_id: this.lead.province_id,
      suburbs: null,
      suburbsBool: false,
      range: {
        lower: this.lead.fromPriceText,
        upper: this.lead.toPriceText,
      },
      amenities: [],
      propertyTypes: new_propertyTypes,
      types: [this.lead.operation],
    };
    const params = {
      data: parametrosBusqueda,
      type: 1,
    };
    console.log("PARAMS DE LA BUSQUEDA HERMANO CUANDO NOOO ESTA LOGUEADO", params);
    this._LandingService.allPropertiesSearchResults(params).then(
      (resp: Property[]) => {
        console.log("RESPUESTA DE LA BUSQUEDA HERMANO CUANDO NOOO LOGUEADO", resp);
        console.log(resp);
        this.properties = this.temp = resp;
        this.sizeTable = this.temp.length;
        this.getPageData();
        this.pageSize = 9;
      },
      (error: any) => {
        console.log("Error de servidor APSR", error);
        Swal.fire("Error de servidor APSR", "Favor de intentarlo nuevamente", "error");
      }
    );
    // }
  }

  getPageData() {
    this.properties = this.temp.slice((this.page - 1) * this.pageSize, (this.page - 1) * this.pageSize + this.pageSize);
  }

  favorite(pro: Property) {
    this._propertyService.setFavoAgent(pro.id, this.userLoggeado.agentId).then(
      (resp: any) => {
        pro.landingFavorite = !pro.landingFavorite;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  cambiaVista(): void {
    if (!this.mapa) {
      this.mapa = true;
      this.button = "Bloque";
      setTimeout(async () => {
        this.initMap();
      }, 1000);
    } else {
      var host = window.location.host;
      this.button = "Mapa";
      const domain = host.split(".")[1];
      let params;
      if (domain == "in-mo" || domain == "inmoapp") {
        params = {
          data: this.consulta,
          type: 1,
          domain: host.split(".")[0],
        };
      } else {
        params = {
          data: this.consulta,
          type: 1,
          domain: environment.DOMAIN,
        };
      }
      this.mapa = false;
      this.properties = [];
      this._LandingService.allPropertiesSearchResults(params).then(
        (resp: Property[]) => {
          this.properties = this.temp = resp;
          this.sizeTable = this.temp.length;
          this.getPageData();
          this.pageSize = 9;
        },
        (error: any) => {
          console.log(error);
        }
      );

      this.pageSize = 9;
    }
  }

  initMap() {
    this.map = new google.maps.Map(document.getElementById("map"), {
      center: this.inicio,
      zoom: 15,
      panControl: false,
      streetViewControl: false,
      scaleControl: false,
      overviewMapControl: false,
      mapTypeControl: false,
    });
    let coordInit;
    let params2;
    this.map.addListener("idle", () => {
      coordInit = JSON.parse(JSON.stringify(this.map.getBounds()));
      var host = window.location.host;
      const domain = host.split(".")[1];
      let params;
      if (domain == "in-mo" || domain == "inmoapp") {
        params = {
          coordsLat: [coordInit.north, coordInit.south],
          coordsLng: [coordInit.east, coordInit.west],
          data: this.consulta,
          type: 1,
          domain: host.split(".")[0],
        };
      } else {
        params = {
          coordsLat: [coordInit.north, coordInit.south],
          coordsLng: [coordInit.east, coordInit.west],
          data: this.consulta,
          type: 1,
          domain: environment.DOMAIN,
        };
      }

      this._LandingService.allPropertiesSearchResults(params2).then(
        (resp: Property[]) => {
          this.properties = this.temp = resp;
          this.agregarMarkers();

          this.sizeTable = this.temp.length;
          this.getPageData();
          this.pageSize = 9;
        },
        (error: any) => {
          console.log(error);
        }
      );
    });

    this.agregarMarkers();
    this.map.addListener("dragend", () => {
      let coord = JSON.parse(JSON.stringify(this.map.getBounds()));
      var host = window.location.host;
      const domain = host.split(".")[1];
      let params;
      if (domain == "in-mo" || domain == "inmoapp") {
        params = {
          coordsLat: [coord.north, coord.south],
          coordsLng: [coord.east, coord.west],
          data: this.consulta,
          type: 1,
          domain: host.split(".")[0],
        };
      } else {
        params = {
          coordsLat: [coord.north, coord.south],
          coordsLng: [coord.east, coord.west],
          data: this.consulta,
          type: 1,
          domain: environment.DOMAIN,
        };
      }

      this._LandingService.allPropertiesSearchResults(params).then(
        (resp: Property[]) => {
          this.properties = this.temp = resp;
          this.agregarMarkers();

          this.sizeTable = this.temp.length;
          this.getPageData();
          this.pageSize = 9;
        },
        (error: any) => {
          console.log(error);
        }
      );
    });

    this.map.addListener("dragstart", () => {
      this.markers.forEach((element) => {
        element.setMap(null);
      });
    });
  }

  agregarMarkers(): void {
    const icon = {
      url: "assets/icon/home.png",
      scaledSize: new google.maps.Size(50, 50),
    };
    this.properties.forEach((element) => {
      const contentString = `
      <div style="width: 18rem;height:100%">
        <img src="${this.url + element.propertyImages[0].path}" class="card-img-top" alt="...">
        <div class="card-body ml-0">
        <h6 class="card-title m-0">${element.title}</h6>
          <h5 class="card-title m-0"><small class="text-muted">${this._currencyPipe.transform(
            element.price
          )}</small></h5>
          <a class="btn btn-primary" href="/detalles/${element.id}/reaestnu" >Ver detalles</a>
        </div>
      </div>
      `;

      const infowindow = new google.maps.InfoWindow({
        content: contentString,
        ariaLabel: "Uluru",
      });

      const marker = new google.maps.Marker({
        position: { lat: Number(element.latitude), lng: Number(element.longitude) },
        map: this.map,
        icon,
      });

      marker.addListener("click", () => {
        infowindow.open({
          anchor: marker,
          map: this.map,
        });
      });

      this.markers.push(marker);
    });
  }

  verDetalles(id: number, getURL?: boolean) {
    // setTimeout(() => {
      var host = window.location.host;
      const domain = host.split(".")[1];
      let params;
      if (domain == "in-mo" || domain == "inmoapp") {
        params = {
          data: this.consulta,
          type: 1,
          domain: host.split(".")[0],
        };
      } else {
        params = {
          data: this.consulta,
          type: 1,
          domain: environment.DOMAIN,
        };
      }

      const ruta = "https://" + params.domain + ".inmoapp.mx/detalles/" + id;

      if(getURL){
        return ruta;
      } else {
        window.open(ruta, "_blank");
      }
    // }, 500);
  }

  tipoPropiedad(type: number): string {
    if (type === 1) {
      return "Casa";
    }
    if (type === 2) {
      return "Departamentos";
    }
    if (type === 3) {
      return "Bodega";
    }
    if (type === 4) {
      return "Terreno";
    }
    if (type === 5) {
      return "Bodega/nave";
    }
    if (type === 6) {
      return "Campestre/Rancho";
    }
    if (type === 7) {
      return "Oficina";
    }
    if (type === 8) {
      return "Edificio";
    }
    return "";
  }

  ordena(tipo): void {
    if (tipo === 1) {
      this.properties.sort((a, b) => b.price - a.price);
    }
    if (tipo === 2) {
      this.properties.sort((a, b) => a.price - b.price);
    }
    if (tipo === 3) {
      this.properties.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
    }
    if (tipo === 4) {
      this.properties.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
    }
  }

  cantidad(nombre: string, cant: number, id: number): string {
    if (id === 1 || id === 2 || id === 3) {
      return cant + "+ " + nombre;
    } else if (id === 4 || id === 5) {
      return cant + " " + nombre;
    } else if (id === 7 || id === 8 || id === 9) {
      return nombre;
    } else if (id === 23) {
      return cant + " año(s) de antigüedad";
    } else {
      return nombre;
    }
  }

  abreModal(modalBasic): void {
    this.modalService.open(modalBasic, {
      size: "lg",
    });
  }

  abreModal2(modalUbication): void {
    this.modalUbi = this.modalService.open(modalUbication, {
      size: "lg",
      backdrop: "static",
      keyboard: false,
    });
  }

  busqueda(): void {
    this.parametrosBusqueda.state_id = this.state.id;
    this.parametrosBusqueda.exclusive = this.exclusive;
    this.parametrosBusqueda.province_id = this.province.id;
    this.parametrosBusqueda.amenities.push(this.years);
    if (this.parametrosBusqueda.suburbs !== null) {
      this.parametrosBusqueda.suburbsBool = true;
    } else {
      this.parametrosBusqueda.suburbsBool = false;
    }

    const route = this._route.snapshot;

    if (
      this.parametrosBusqueda.types !== "" &&
      this.parametrosBusqueda.propertyTypes !== null &&
      this.parametrosBusqueda.range.lowerText !== "" &&
      this.parametrosBusqueda.range.upperText !== ""
    ) {
      if (this.parametrosBusqueda.range.upper >= this.parametrosBusqueda.range.lower) {
        this._LandingService.sharingValue = this.parametrosBusqueda;
        this.modalService.dismissAll();
        this._router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
          this._router.navigate(["/cln/:client_name"]);
        });
      } else {
        this.precioMal = false;
      }
    } else {
      this.obligatorios = true;
    }
  }

  transformAmount(element, type): void {
    if (element.target.value) {
      if (type === 1) {
        this.parametrosBusqueda.range.lower = parseFloat(this.parametrosBusqueda.range.lowerText.replace(",", ""));
        this.parametrosBusqueda.range.lowerText = this._currencyPipe.transform(
          this.parametrosBusqueda.range.lower,
          " ",
          "symbol",
          "1.2-2"
        );
        element.target.value = this.parametrosBusqueda.range.lowerText;
      }

      if (type === 2) {
        this.parametrosBusqueda.range.upper = parseFloat(this.parametrosBusqueda.range.upperText.replace(",", ""));
        this.parametrosBusqueda.range.upperText = this._currencyPipe.transform(
          this.parametrosBusqueda.range.upper,
          " ",
          "symbol",
          "1.2-2"
        );
        element.target.value = this.parametrosBusqueda.range.upperText;
      }
    }
  }

  getProvinces(event): void {
    this.province.id = null;
    this.province.name = "";
    this.state.name = event.name;
    localStorage.setItem("stateIdCurrent", event.id);
    localStorage.setItem("stateNameCurrent", event.name);

    this._LandingService.getProvinceById(event.id).then(
      (data: any) => {
        this.provincesBasic = data;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getSuburbs(event): void {
    this.province.name = event.name;

    if (!localStorage.getItem("provinceIdCurrent")) {
      this.province.id = 1847;
      this.province.name = "San Luis Potosí";
      localStorage.setItem("provinceIdCurrent", this.province.id.toString());
      localStorage.setItem("provinceNameCurrent", this.province.name);
    } else {
      if (event.id != 0) {
        localStorage.setItem("provinceIdCurrent", event.id);
        localStorage.setItem("provinceNameCurrent", event.name);
        this.province.id = event.id;
        this.province.name = event.name;
      }
    }

    this._LandingService.getSuburbsById(event.id).then(
      (data: any) => {
        this.suburbsBasic = data;
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  checkSelect() {
    this.bandProvince = true;

    if (!this.province.id) {
      this.bandProvince = false;
    } else {
      this.bandProvince = true;
      this.modalUbi.close();
    }
  }

  public onQtrInputChange(event: any, id) {
    if (id.toString() === "1") {
      if (event.replace(/\D/g, "") === "") {
        this.parametrosBusqueda.range.lower = 0;
      } else {
        this.parametrosBusqueda.range.lower = Number(event.replace(/\D/g, ""));
      }
    } else {
      if (event.replace(/\D/g, "") === "") {
        this.parametrosBusqueda.range.upper = 0;
      } else {
        this.parametrosBusqueda.range.upper = Number(event.replace(/\D/g, ""));
      }
    }
  }

  public onFocusCommaInput(id) {
    if (id.toString() === "1") {
      this.listener = this.renderer.listen("window", "keyup", (event) => {
        this.parametrosBusqueda.range.lowerText = (<HTMLInputElement>document.getElementById("minPrice")).value.replace(
          /[^\d,]/g,
          ""
        );
      });
    } else {
      this.listener = this.renderer.listen("window", "keyup", (event) => {
        this.parametrosBusqueda.range.upperText = (<HTMLInputElement>document.getElementById("maxPrie")).value.replace(
          /[^\d,]/g,
          ""
        );
      });
    }
  }

  public onBlurCommaInput() {
    this.listener();
  }

  mostrarBusquedaAvanzada(): void {
    if (this.showBusquedaAvanzada === true) {
      this.iconShowBusquedaAvanzada = "chevron-down";
      this.showBusquedaAvanzada = false;
    } else {
      this.iconShowBusquedaAvanzada = "chevron-up";
      this.showBusquedaAvanzada = true;
    }
    console.log(this.iconShowBusquedaAvanzada);
  }

  sendWhatsapp(property: any) {
    console.log("PROPERTY", property);

    const agent = this.lead.agent;
    const ruta = this.verDetalles(property.id, true);
    const msj = `Hola, ${agent.user.firstName}! Estoy interesado en la propiedad ${property.title} con clave ${property.id}. Me podrías proporcionar más información? Link --> ${ruta}`;
    const url = `https://wa.me/${agent.user.phone}?text=${msj}`;


    window.open(url, "_system");
  }
}
